import { useRef, useEffect, useState } from "react";
import { useScrollReveal } from "../useScrollReveal";
import "./Es3Manifesto.css";

const LINES = [
  { num: "01", text: "You do not need a brand." },
  { num: "02", text: "You do not need a following." },
  { num: "03", text: "You need work you made yourself," },
  { num: "04", text: "a story behind it," },
  { num: "05", text: "and the nerve to put it on a wall" },
  { num: "06", text: "where strangers can see it." },
];

function ManifestoLine({ item, index }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
      else setVisible(false);
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const isEven = index % 2 === 1;

  return (
    <div
      ref={ref}
      className={`es3-mf-line${isEven ? " es3-mf-line-r" : ""}`}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateX(0)" : isEven ? "translateX(48px)" : "translateX(-48px)",
        transition: `opacity 0.8s ease ${index * 60}ms, transform 0.8s cubic-bezier(.2,.6,.2,1) ${index * 60}ms`,
      }}
    >
      <span className="es3-mf-num">{item.num}</span>
      <span className="es3-mf-text">{item.text}</span>
    </div>
  );
}

function Es3Manifesto() {
  const { ref: headRef, fromDir: headFromDir } = useScrollReveal(0.1);
  const { ref: footRef, fromDir: footFromDir } = useScrollReveal(0.1);

  return (
    <section className="es3-section es3-manifesto" id="es3-manifesto">
      <div className="es3-mf-inner">
        <div className="es3-mf-header" ref={headRef} style={headFromDir(0)}>
          <div className="es3-hand" style={{ color: "rgba(236,229,211,.65)" }}>the point</div>
          <p className="es3-mf-sub">This room has one rule about who gets in.</p>
        </div>

        <div className="es3-mf-lines">
          {LINES.map((item, i) => (
            <ManifestoLine key={i} item={item} index={i} />
          ))}
        </div>

        <div className="es3-mf-footer" ref={footRef} style={footFromDir(200)}>
          <div className="es3-mf-rule" />
          <p className="es3-mf-sig">This room was built for the first shelf you ever had.</p>
        </div>
      </div>
    </section>
  );
}

export default Es3Manifesto;
